<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_14"></a><i>If the elephant vanished</i></p>
<p class="dedication1"><i>the loss to human laughter</i>,</p>
<p class="dedication1"><i>wonder and tenderness would</i></p>
<p class="dedication1"><i>be a calamity</i>.</p>
<p class="dedication2">— V. S. P<span class="small">RITCHETT</span></p>
<p class="dedication1">reviewing <i>The Roots of Heaven</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?1b7a3f78